export const REGEX_DATE_TIME = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

export const REGEX_DIGITS_NOT_ZERO = /^-1$|^[1-9]\d*$/;
export const REGEX_DIGITS = /^\d+$/;
export const REGEX_DIGITS_AND_LETTERS = /^[A-Za-z0-9]*$/;

export const REGEX_EMBED = /<([\s\S]*?)\b[^>]*>([\s\S]*?)<\/([\s\S]*?)>/;

export const REGEX_EMAIL =
     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const REGEX_LAST_SLASH_CHARACTER = /.$/;

export const REGEX_ONLY_SPACES = /^\s*$/;

export const REGEX_PHONE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const REGEX_SCRIPT = /<script([\s\S]*?)>*$/;

export const REGEX_START_SPACE = /^\s+/g;
export const REGEX_END_SPACE = /\s+$/g;

export const REGEX_URL =
     /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i; //eslint-disable-line

export const REGEX_URL_WWW = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g;

export const REGEX_VALID_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-[0-9a-f]{13}$/i;

export const REGEX_WISTIA = /https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/.*/;

export const REGEX_YOUTUBE = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/; //eslint-disable-line

export const REGEX_ZIP_CODE = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
